var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { t } from '@lingui/macro';
import { TableBodyCell } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SignRequestStatus } from 'shared/domains/apollo/generated/types';
import { EmptyCell } from '../EmptyCell';
import { Label, NoWrap } from './styled';
const STATES_WITHOUT_STATUS = [
    SignRequestStatus.Cancelling,
    SignRequestStatus.Cancelled,
    SignRequestStatus.Creating,
];
const getIconFromStatus = (status) => {
    switch (status) {
        case SignRequestStatus.Opened:
        case SignRequestStatus.Pending:
            return <Falcon icon="circle" $size={16} $color="blue.500"/>;
        case SignRequestStatus.Failed:
        case SignRequestStatus.Rejected:
            return <Falcon icon="circle-xmark" $size={16} $color="red.500"/>;
        case SignRequestStatus.Unknown:
            return <Falcon icon="circle-exclamation" $size={16} $color="yellow.500"/>;
        case SignRequestStatus.Signed:
            return <Falcon icon="circle-check" $size={16} $color="green.500"/>;
        default:
            return <Falcon icon="circle-exclamation" $size={16}/>;
    }
};
const statusLabels = new Map([
    [SignRequestStatus.Opened, t `Pending`],
    [SignRequestStatus.Pending, t `Pending`],
    [SignRequestStatus.Rejected, t `Declined`],
    [SignRequestStatus.Signed, t `Signed`],
    [SignRequestStatus.Failed, t `Failed`],
    [SignRequestStatus.Unknown, t `Unknown`],
]);
export function StatusCell(props) {
    const { status } = props, restProps = __rest(props, ["status"]);
    const headers = 'filesystemtable-status';
    if (!status || STATES_WITHOUT_STATUS.includes(status)) {
        return <EmptyCell headers={headers} {...restProps}/>;
    }
    const statusLabel = statusLabels.get(status);
    return (<TableBodyCell headers={headers} {...restProps}>
      <NoWrap>
        {getIconFromStatus(status)}
        <Label>{statusLabel}</Label>
      </NoWrap>
    </TableBodyCell>);
}
